<template>
  <div>
    <ec-flex v-if="!collapsed" wrap alignItems="center">
      <slot></slot>
    </ec-flex>
    <n-popover v-else trigger="hover" placement="bottom-end">
      <template #trigger>
        <ec-button type="primary">{{ collapseText }}</ec-button>
      </template>
      <ec-flex wrap style="width: 460px">
        <slot></slot>
      </ec-flex>
    </n-popover>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue"
import { useEnvStore } from "@/store/EnvStore"
import EcButton from "@/components/EcButton.vue"
import EcFlex from "@/components/EcFlex.vue"

// 按钮组容器：页面宽度充足时平铺按钮，不足时收缩为单个按钮，hover 弹出按钮面板
const props = withDefaults(
  defineProps<{
    collapseWidth?: number
    collapseText?: string
  }>(),
  {
    collapseWidth: 0,
    collapseText: "操作",
  }
)

// 页面宽度取自 EnvStore（App.vue 在初始化和 resize 时统一维护）
const envStore = useEnvStore()
const collapsed = computed(() => envStore.size.width < props.collapseWidth)
</script>
<style scoped></style>
